import { Typography, Stack, Avatar, Badge, Card, CardContent, Divider, Link, IconButton, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Button } from "@mui/material";
import { AvatarColor } from "../models/AvatarColor";
import { Entity, PermissionLevel } from "./Permisos";
import AutorenewOutlinedIcon from '@mui/icons-material/AutorenewOutlined';
import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined';
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined';
import AccessTimeOutlinedIcon from '@mui/icons-material/AccessTimeOutlined';
import { User } from "../Settings/Users/User";
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import NotificationAddOutlinedIcon from '@mui/icons-material/NotificationAddOutlined';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';
import React from "react";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import SecurityTrimmer from "../components/Utilities/SecurityTrimmer";
import Man2OutlinedIcon from '@mui/icons-material/Man2Outlined';
import Woman2OutlinedIcon from '@mui/icons-material/Woman2Outlined';

export default class Common {
    private static AVATAR_COLORS: AvatarColor[] = [];

    //public static END_POINT: string = "http://localhost:5206";
    public static END_POINT: string = "https://manager.ad735.es/api";
    public static DATA_FIELDS: string[] = ["Nombre", "Apellidos", "Telefono", "TipoVia", "NombreVia", "NumeroVia", "RestoDireccion", "CP", "Municipio", "Provincia", "FechaNacimiento", "Email", "Sexo", "URL", "IP", "CupsLuz", "CupsGas"];
    public static DATA_FIELDS_JSON: string[] = ["nombre", "apellidos", "telefono", "tipoVia", "nombreVia", "numeroVia", "restoDireccion", "cp", "municipio", "provincia", "fechaNacimiento", "email", "sexo", "URL", "ip", "CupsLuz", "CupsGas"];
    public static DATA_DISPLAY_FIELDS: string[] = ["Nombre", "Apellidos", "Telefono", "Tipo de vía", "Nombre de vía", "Numero de vía", "Resto de la direccion", "CP", "Municipio", "Provincia", "Fecha de nacimiento", "Email", "Sexo", "URL", "IP", "CUP LUZ", "CUP GAS"];
    public static WOMAN_COLOR: string = 'rgba(255, 46, 183, .3)';
    public static MAN_COLOR: string =  'rgba(0, 178, 220, .3)';
    public static WOMAN_BORDER_COLOR: string = 'rgba(255, 46, 183, 1)';
    public static MAN_BORDER_COLOR: string =  'rgba(0, 178, 220, 1)';
    public static MAN_HEX_START_COLOR: string = '#8ECAE6';
    public static MAN_HEX_END_COLOR: string = '#8ECAE6';
    public static WOMAN_HEX_START_COLOR: string = '#FFB3C1';
    public static WOMAN_HEX_END_COLOR: string = '#FFB3C1';
    public static ERROR_COLOR: string = 'rgba(186, 0, 13, .4)';
    public static SUCCESS_COLOR: string = 'rgba(53, 122, 56, .4)';
    public static ERROR_COLOR_DARK: string = 'rgba(186, 0, 13, 1)';
    public static SUCCESS_COLOR_DARK: string = 'rgba(53, 122, 56, 1)';
    public static PALLETE: string[] = ["#EE6352", "#59CD90", "#3FA7D6", "#FAC05E", "#F79D84", "#FFBE0B", "#FB5607", "#EAE870", "#47BC53", "#DBC515", "#5069E4", "#41E1D1", "#2BB812", "#EB6D17", "#A36D3A", "#C76542", "#C76542", "#C76542", "#E01EAD", "#D6BD69", "#692BC7", "#E63410", "#4CE09F", "#D16DE1", "#51A4E0", "#E16A65", "#E09E29", '#1f77b4', '#ff7f0e','#2ca02c','#d62728','#9467bd','#8c564b','#e377c2','#7f7f7f','#bcbd22','#17becf','#7fc97f','#beaed4','#fdc086','#ffff99','#386cb0','#f0027f','#bf5b17','#666666','#1b9e77','#d95f02','#7570b3','#e7298a','#66a61e','#e6ab02','#a6761d','#666666','#a6cee3','#1f78b4','#b2df8a','#33a02c','#fb9a99','#e31a1c','#fdbf6f','#ff7f00','#cab2d6','#6a3d9a','#ffff99','#b15928','#fbb4ae','#b3cde3','#ccebc5','#decbe4','#fed9a6','#ffffcc','#e5d8bd','#fddaec','#f2f2f2','#b3e2cd','#fdcdac','#cbd5e8','#f4cae4','#e6f5c9','#fff2ae','#f1e2cc','#cccccc','#e41a1c','#377eb8','#4daf4a','#984ea3','#ff7f00','#ffff33','#a65628','#f781bf','#999999','#66c2a5','#fc8d62','#8da0cb','#e78ac3','#a6d854','#ffd92f','#e5c494','#b3b3b3','#8dd3c7','#ffffb3','#bebada','#fb8072','#80b1d3','#fdb462','#b3de69','#fccde5','#d9d9d9','#bc80bd','#ccebc5','#ffed6f','#4e79a7','#f28e2c','#e15759','#76b7b2','#59a14f','#edc949','#af7aa1','#ff9da7','#9c755f','#bab0ab']
    public static FIELD_PALETTE_MAP: any[] = [
        {
            field: 'telefono',
            colors: ["#cfe8ef", "#85c7de"]
        },
        {
            field: 'email',
            colors: ["#ffd670", "#ff9770"]
        },
        {
            field: 'tipovia',
            colors: ["#daf2d7", "#90cf8e"]
        },
        {
            field: 'nombrevia',
            colors: ["#f5ebe0", "#d0b8ac"]
        },
        {
            field: 'numerovia',
            colors: ["#dceef3", "#72bbce"]
        },
        {
            field: 'restodireccion',
            colors: ["#f3cfce", "#ec698f"]
        },
        {
            field: 'cp',
            colors: ["#fcefb4", "#f9dc5c"]
        },
        {
            field: 'municipio',
            colors: ["#bebcfc", "#c46df7"]
        },
        {
            field: 'CupsLuz',
            colors: ["#ebd9fc", "#9667e0"]
        },
        {
            field: 'cupsgas',
            colors: ["#ffe69e", "#ffa86b"]
        },
        {
            field: 'comunidadautonoma',
            colors: ['#2CA02C', "#98DF8A"]
        }
    ]

    public static getUrlParam(param: string): string {
        const url = window.location.href;
        const queryString = url.split('?');
        if(queryString.length > 1) {
            const dictionary = queryString[1].split('&');
            for (let i = 0; i < dictionary.length; i++) {
                const entry = dictionary[i].split('=');
                const key = entry[0];
                if(key.toLowerCase() == param.toLowerCase()) {
                    return entry[1];
                }
            }
        }

        return "";
    }

    public static IsNullOrEmpty(text: string) {
        return text == null || text.trim() == '';
    }

    public static FilterNormalizationData(sourceArray: any[], targetArray: any[], field: string): any[] {
        const normalizationErrors = sourceArray.filter((item: any) => {
            return item.campo.toLowerCase() == field.toLowerCase();
        });

        const auxArray: any[] = [];

        for (let i = 0; i < targetArray.length; i++) {
            for(let j = 0; j < normalizationErrors.length; j++) {
                if(targetArray[i].id == normalizationErrors[j].normalizacionDataId) {
                    const item = auxArray.find((a) => {
                        return a.id == targetArray[i].id
                    });

                    if(item == null) {
                        auxArray.push(targetArray[i]);
                    }
                }
            }
        }

        return auxArray;
    }

    public static GetUrlParam(param: string): string {
        const url = window.location.href;
        if(window.location.href.indexOf('?') == -1) {
            return param;
        }

        const queryString = url.split("?")[1];
        const queryStringDictionary = queryString.split("&");

        for(let i = 0; i < queryStringDictionary.length; i++) {
            const entry = queryStringDictionary[i].split("=");

            if (entry[0].toLowerCase() == param.toLowerCase()) {
                return entry[1];
            }
        }

        return param;
    }

    public static GetFieldDisplayName(key: string): string {
        return this.DATA_DISPLAY_FIELDS[this.DATA_FIELDS_JSON.indexOf(key)];
    }

    public static GetDataFieldDisplayName(key: string): string {
        switch(key.toLocaleLowerCase()) {
            case 'name':
            case 'nombre':
                return 'Nombre';
            case 'id':
                return 'ID';
            case 'creado':
                return 'Creado';
            case 'creadopor':
                return 'Creado por';
            case 'modificadopor':
                return 'Modificado por';
            case 'modificado':
                return 'Modificado';
            case 'codigo':
                return 'Código';
            case 'comunidadautonoma':
                return 'Comunidad autónoma';
            case 'provincia':
                return 'Provincia';
            case 'variacion':
                return 'Variación';
            case 'municipio':
                return 'Municipio';
            case 'tipovia':
                return 'Tipo de vía';
            case 'sexo':
                return 'Sexo';
            case 'nombrepila':
                return 'Nombre de pila';
            default:
                return key;
        }
    }

    public static GetUser(): any {
        if(localStorage.getItem("user") == null) {
            window.location.href = "/login";
        }

        return JSON.parse(localStorage.getItem("user")!)["usuario"];
    }

    public static GetUserProp(prop: string): string {
        if(localStorage.getItem("user") == null) {
            window.location.href = "/login";
        }

        if(JSON.parse(localStorage.getItem("user")!)["usuario"][prop] == null) {
            window.location.href = "/login";
        }

        return JSON.parse(localStorage.getItem("user")!)["usuario"][prop];
    }

    public static GetToken(): string {
        if(localStorage.getItem("user") == null) {
            window.location.href = "/login";
        }
        
        return JSON.parse(localStorage.getItem("user")!)["token"];
    }

    public static SetLocalStorage(): string {
        if(localStorage.getItem("user") == null) {
            window.location.href = "/login";
        }
        
        return JSON.parse(localStorage.getItem("user")!)["token"];
    }

    public static GetNameInitials(name: string) : string {
        const parts = name.split(' ');
        const initials: string[] = [];

        for(let i = 0; i < 2; i++) {
            const initial = parts[i].substring(0, 1).toUpperCase();
            initials.push(initial.replaceAll('Á', 'A').replaceAll('É', 'E').replaceAll('Í', 'I').replaceAll('Ó', 'O').replaceAll('Ú', 'U'));
        }

        return initials.join('');
    }

    public static RenderCell(row: any, key: string) {
        let value = row[key];

        if(typeof value === 'object') {
            value = '';
        }
        
        return (
            <Typography variant='caption'>
                {
                    value ? value.toString().toUpperCase() : ""
                }
            </Typography>
        )
    }

    public static RenderDate(row: any, key: string) {
        if(row[key].indexOf === undefined) {
            return (
                ``
            )
        }
        const date = new Date(row[key]);

        return (
            `${date.toLocaleDateString()} ${date.toLocaleTimeString()}`
        )
    }

    public static RenderDate2(value: string) {
        const date = new Date(value);

        return (
            `${date.toLocaleDateString()} ${date.toLocaleTimeString()}`
        )
    }

    public static RenderSex(value: string) {
        const date = new Date(value);

        return (
            <React.Fragment>
                {
                    value?.toLowerCase() == 'h' && (
                        <Man2OutlinedIcon style={{fontSize: '20px', position: 'relative', top: '6px'}}/>
                    )
                }
                {
                    value?.toLowerCase() == 'm' && (
                        <Woman2OutlinedIcon style={{fontSize: '20px', position: 'relative', top: '6px'}}/>
                    )
                }
            </React.Fragment>
        )
    }

    public static RenderBoolean(row: any, key: string) {
        return (
            <React.Fragment>
                {
                    row[key] && (
                        <CheckCircleIcon color='success' style={{position: 'relative', top: '7px'}}/>
                    )
                }
                {
                    !row[key] && (
                        <CancelIcon color='error' style={{position: 'relative', top: '7px'}}/>
                    )
                }
            </React.Fragment>
        )
    }

    public static RenderUser(row: any, key: string) {
        if(row[key] == null) {
            return;
        }
        
        const name = `${row[key].split(',')[1]} ${row[key].split(',')[0]}`.trim();
        
        let avatarColor = this.AVATAR_COLORS.find((x: AvatarColor) => {
            return x.nombre.toLowerCase() == name.toLowerCase();
        });

        if(avatarColor == null) {
            avatarColor = new AvatarColor();
            avatarColor.nombre = name;
            avatarColor.color = `#${Math.floor(Math.random()*16777215).toString(16)}`;

            console.log(avatarColor.color);

            this.AVATAR_COLORS.push(avatarColor);
        }
        
        return (
            <Stack direction="row" spacing={1}>
                <Avatar alt={name} src={(key.toLowerCase() == 'creadopor' ? row['creadoPorAvatar'] : row['modificadoPorAvatar'])} sx={{ width: 32, height: 32, bgcolor: (key.toLowerCase() == 'creadopor' ? row['creadoPorAvatarColor'] : row['modificadoPorAvatarColor']) }} style={{position: 'relative', top: '10px'}}>
                    <Typography variant='caption' style={{position: 'relative', top: '2px'}}>
                        {
                            Common.GetNameInitials(name)
                        }
                    </Typography>
                </Avatar>
                <Typography variant='caption' style={{position: 'relative', top: '18px'}}>
                    {
                        row[key]
                    }
                </Typography>
            </Stack>
        )
    }

    public static GetUserCard(users: User[], id: number, entity: Entity, userActivity: any[], onNotifyPress: any) {
        if(users.length == 0) {
            return;
        }

        const user = users.find((value: User) => {
            return value.id == id;
        });

        if(user == null) {
            return;
        }

        const activity: any[] = userActivity.filter((value: any) => {
            return value.creadoPor == id || value.modificadoPor == id;
        });

        activity.sort((a: any, b: any) => {
            if(a.id < b.id) return -1;
            if(a.id > b.id) return 1;
            return 0;
        });

        const topActivity: any[] = activity.slice(0, 5);
        
        return (
            <div className='userContainer'>
                <Stack direction="row" spacing={1}>
                    <Avatar alt={user?.displayName} src={user.avatar} sx={{ width: 32, height: 32, bgcolor: user.avatarColor }} style={{position: 'relative', top: '10px'}}>
                        <Typography variant='caption' style={{position: 'relative', top: '2px'}}>
                            {
                                Common.GetNameInitials(user.displayName!)
                            }
                        </Typography>
                    </Avatar>
                    <Typography variant='caption' style={{position: 'relative', top: '18px'}}>
                        {
                            user.displayName
                        }
                    </Typography>
                </Stack>
                <Card className='userCard'>
                    <CardContent>
                        <Stack direction="row" spacing={1} style={{borderBottom: 'solid 1px #ccc', paddingBottom: '10px', marginBottom: '10px'}}>
                            <Avatar alt={user?.displayName} src={user.avatar} sx={{ width: 64, height: 64, bgcolor: user.avatarColor }}>
                                <Typography variant='caption' style={{position: 'relative', top: '2px'}}>
                                    {
                                        Common.GetNameInitials(user.displayName!)
                                    }
                                </Typography>
                            </Avatar>
                            <Typography variant='h5' style={{position: 'relative', top: '14px'}}>
                                {
                                    user.displayName
                                }
                            </Typography>
                        </Stack>
                        <Typography variant='body2' fontWeight={500} marginBottom={'10px'} fontSize={'.9em'}>
                            Contacto
                        </Typography>
                        <Stack direction="row" spacing={1} justifyContent={'space-between'}>
                            <Typography variant="body2" fontSize={'.9em'} fontWeight={100} color='primary'>
                                <EmailOutlinedIcon style={{fontSize: '1em', position: 'relative', top: '3px', marginRight: '3px'}}/>
                                {
                                    user.userName
                                }
                            </Typography>
                            <IconButton color='primary' title='Enviar notificación' style={{position: 'relative', top: '-10px'}} onClick={() => {
                                if(onNotifyPress != null) {
                                    onNotifyPress();
                                }
                            }}>
                                <NotificationAddOutlinedIcon/>
                            </IconButton>
                        </Stack>
                        <Divider style={{marginBottom: '10px'}}/>
                        <Typography variant='body2' fontWeight={500} fontSize={'.9em'}>
                            {
                                `Actividad en ${this.GetEntityName(entity)}`
                            }
                        </Typography>
                        <List disablePadding>
                            {
                                topActivity.map((value: any, index: number) => {
                                    return (
                                        <ListItem disablePadding disableGutters key={`user-activity-${index}`}>
                                            <ListItemButton>
                                                <ListItemIcon>
                                                    {
                                                        value.creado == value.modificado && (
                                                            <AddOutlinedIcon className='userCardActivityIcon'/>
                                                        )
                                                    }
                                                    {
                                                        value.creado < value.modificado && (
                                                            <EditOutlinedIcon/>
                                                        )
                                                    }
                                                </ListItemIcon>
                                                <ListItemText primary={<Typography fontSize={'.9em'}>{value['nombre']}</Typography>} secondary={<Typography fontSize={'.7em'}>{`Modificado ${new Date(value.modificado).toLocaleDateString()} ${new Date(value.modificado).toLocaleTimeString()}`}</Typography>}/>
                                            </ListItemButton>
                                        </ListItem>
                                    )
                                })
                            }
                        </List>
                    </CardContent>
                </Card>
            </div>
        )
    }

    public static GetColor() {
        const index = Math.round(Math.random() * (this.PALLETE.length - 1));
        console.log('GetColor', index);
        return this.PALLETE[index];
    }

    public static SetColors(data: any[]): any[] {
        const auxData: any[] = JSON.parse(JSON.stringify(data));
        for(let i = 0; i < auxData.length; i++) {
            if(auxData[i].color == null) {
                const index = Math.round(Math.random() * (this.PALLETE.length - 1));
                auxData[i].color = this.PALLETE[index];
            }
        }

        return auxData;
    }

    public static GetEntityName(entityId: number): string {
        let title: string = '';

        switch(entityId) {
            case Entity.Apellidos:
                title = "Apellidos";
                break;
            case Entity.Clientes:
                title = "Clientes";
                break;
            case Entity.ComunidadesAutonomas:
                title = "Comunidades autónomas";
                break;
            case Entity.Configuracion:
                title = "Configuración";
                break;
            case Entity.Consolidaciones:
                title = "Consolidaciones";
                break;
            case Entity.Dashboard:
                title = "Cuadro de mando";
                break;
            case Entity.Datos:
                title = "Datos";
                break;
            case Entity.IPS:
                title = "IPs";
                break;
            case Entity.Municipios:
                title = "Municipios";
                break;
            case Entity.NivelesPermisos:
                title = "Niveles de permisos";
                break;
            case Entity.NombresPila:
                title = "Nombres de pila";
                break;
            case Entity.Normalizaciones:
                title = "Normalizaciones";
                break;
            case Entity.Permisos:
                title = "Permisos";
                break;
            case Entity.Provincias:
                title = "Provincias";
                break;
            case Entity.TiposVía:
                title = "Tipos de vía";
                break;
            case Entity.Tramero:
                title = "Tramero";
                break;
            case Entity.Usuarios:
                title = "Usuarios";
                break;
            case Entity.VariacionesApellidos:
                title = "Variaciones de apellidos";
                break;
            case Entity.VariacionesMunicipios:
                title = "Variaciones de municipios";
                break;
            case Entity.VariacionesNombresPila:
                title = "Variaciones de nombres de pila";
                break;
            case Entity.VariacionesTiposVía:
                title = "Variaciones de tipos de vía";
                break;
            case Entity.Extracciones:
                title = "Extracciones";
                break;
        }

        return title;
    }

    public static GetEntity(name: string): Entity {
        let entity: Entity = Entity.Apellidos;

        switch(name) {
            case "Apellidos":
                entity = Entity.Apellidos;
                break;
            case "Clientes":
                entity = Entity.Clientes;
                break;
            case "Comunidades autónomas":
                entity = Entity.ComunidadesAutonomas;
                break;
            case "Configuración":
                entity = Entity.Configuracion;
                break;
            case "Consolidaciones":
                entity = Entity.Consolidaciones;
                break;
            case "Cuadro de mando":
                entity = Entity.Dashboard;
                break;
            case "Datos":
                entity = Entity.Datos;
                break;
            case "IPs":
                entity = Entity.IPS;
                break;
            case "Municipios":
                entity = Entity.Municipios;
                break;
            case "Niveles de permisos":
                entity = Entity.NivelesPermisos;
                break;
            case "Nombres de pila":
                entity = Entity.NombresPila;
                break;
            case "Normalizaciones":
                entity = Entity.Normalizaciones;
                break;
            case "Permisos":
                entity = Entity.Permisos;
                break;
            case "Provincias":
                entity = Entity.Provincias;
                break;
            case "Tipos de vía":
                entity = Entity.TiposVía;
                break;
            case "Tramero":
                entity = Entity.Tramero;
                break;
            case "Usuarios":
                entity = Entity.Usuarios;
                break;
            case "Extracciones":
                entity = Entity.Extracciones;
                break;
            case "Variaciones de apellidos":
                entity = Entity.VariacionesApellidos;
                break;
            case "Variaciones de municipios":
                entity = Entity.VariacionesMunicipios;
                break;
            case "Variaciones de nombres de pila":
                entity = Entity.VariacionesNombresPila;
                break;
            case "Variaciones de tipos de vía":
                entity = Entity.VariacionesTiposVía;
                break;
        }

        return entity;
    }

    public static GetColorByStatus(status: string): string {
        let color: string = '#ffcd38';

        switch(status.toLowerCase()) {
            case 'en proceso':
                color = '#4dabf5';
                break;
            case 'finalizado':
                color = '#6fbf73';
                break;
            case 'error':
                color = '#f6685e';
                break;
        }

        return color;
    }

    public static RenderIconStatus(data: any, key: string) {
        switch(data[key].toLowerCase()) {
            case 'pendiente':
                return (
                    <AccessTimeOutlinedIcon color='info' titleAccess={data[key]} style={{position: 'relative', top: '8px'}}/>
                );
            case 'en proceso':
                return (
                    <Badge badgeContent={`${data['progress']}%`} color="info">
                        <AutorenewOutlinedIcon color='warning' titleAccess={data[key]} style={{position: 'relative', top: '0px'}}/>
                    </Badge>
                );
            case 'finalizado':
                return (
                    <CheckCircleOutlineOutlinedIcon color='success' titleAccess={data[key]} style={{position: 'relative', top: '8px'}}/>
                );
            case 'error':
                return (
                    <ErrorOutlineOutlinedIcon color='error' titleAccess={data[key]} style={{position: 'relative', top: '8px'}}/>
                );
        }
    }

    public static RenderCellMenuButton(value: string, onclick: any) {
        return (
            <SecurityTrimmer entity={Entity.ComunidadesAutonomas} permission={PermissionLevel.Editar}>
                <Button variant='text' style={{color: '#333'}} onClick={(event: React.MouseEvent<HTMLButtonElement>) => {
                    onclick(event);
                }}>
                    {
                        value
                    }
                </Button>
            </SecurityTrimmer>
        )
    }
}